import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="column-toggle"
export default class extends Controller {
    static targets = ["checkbox", "cell", "menu"]
    static values = { storageKey: { type: String, default: "productColumnState" } }

    connect() {

        this.element.setAttribute("data-controller-connected", "true")

        // Force hide menu initially to avoid CSS issues
        if (this.hasMenuTarget) {
            this.menuTarget.style.display = 'none';
        }

        this.loadState()

        // Bind the close function so we can remove it later
        this.boundCloseMenu = this.closeMenu.bind(this)
        document.addEventListener('click', this.boundCloseMenu)
    }

    disconnect() {
        document.removeEventListener('click', this.boundCloseMenu)
    }

    closeMenu(e) {
        // If menu is closed (no open class), do nothing
        if (!this.hasMenuTarget || !this.menuTarget.classList.contains('open')) return;

        // If click is inside the dropdown wrapper (which includes button and menu), do nothing
        if (e.target.closest('.dropdown-wrapper')) return;


        this.menuTarget.classList.remove('open')
        this.menuTarget.style.display = 'none'; // Force style sync
    }

    toggleMenu(event) {

        if (event) {
            event.preventDefault()
            event.stopPropagation()
        }


        const isOpening = this.menuTarget.classList.toggle('open')

        // Explicitly sync style.display to be absolutely sure
        if (isOpening) {
            this.menuTarget.style.display = 'block';
        } else {
            this.menuTarget.style.display = 'none';
        }
    }

    toggle(event) {

        const column = event.target.dataset.column
        const isChecked = event.target.checked

        this.setVisibility(column, isChecked)
        this.saveState()
    }

    setVisibility(columnName, isVisible) {
        // Find all cells (th and td) for this column within the controller's element to key scope
        // Use a more generic selector strategy if specific one fails? No, stick to data attribute
        const selector = `[data-column-name="${columnName}"]`
        const cells = this.element.querySelectorAll(selector)



        cells.forEach(cell => {
            // Directly manipulate style to ensure it overrides everything
            if (isVisible) {
                cell.style.display = "" // Reset to default (table-cell)
                cell.classList.remove("hidden")
            } else {
                cell.style.display = "none"
                cell.classList.add("hidden")
            }
        })
    }

    saveState() {
        try {
            const checkboxes = this.checkboxTargets
            const state = {}
            checkboxes.forEach(cb => {
                state[cb.dataset.column] = cb.checked
            })
            localStorage.setItem(this.storageKeyValue, JSON.stringify(state))
        } catch (e) {
            console.error("Error saving state:", e)
        }
    }

    loadState() {
        try {
            const savedState = JSON.parse(localStorage.getItem(this.storageKeyValue) || "{}")

            this.checkboxTargets.forEach(cb => {
                const column = cb.dataset.column
                if (savedState.hasOwnProperty(column)) {
                    cb.checked = savedState[column]
                }
                this.setVisibility(column, cb.checked)
            })
        } catch (e) {
            console.error("Error loading state:", e)
            // Fallback: Ensure everything matches current checkbox state
            this.checkboxTargets.forEach(cb => this.setVisibility(cb.dataset.column, cb.checked))
        }
    }
}
